/* eslint-disable @typescript-eslint/no-explicit-any */
import { put } from 'redux-saga/effects';
import AT from '../../constants/action-types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* run(fnToRun: any) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return yield fnToRun();
  } catch (e: any) {
    if (e.httpStatus) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return yield put({ type: AT.HTTP_ERROR_SAGA, ...e });
    }
    throw e;
  }
}
